import {
    IAppState, AppActionCreators, AppReducer, ICenterResponse, ICenterMetricsResponse, IArrayResponse, IObjectResponse
} from "./application/index";

import {
    IAuthState, IAuthCheck, AuthActionCreators, AuthReducer
} from './authorization/index';

import {
    IUserListState, UserActionCreators, UserListReducer, IVerifyAuthCodeResponse, IRoleListResponse, IGroupListResponse,
    ILookupDataResponse as IUserLookupDataResponse, IGroupLookupDataResponse,
    IGroupData,
    IAddUpdateGroupResponse
} from "./users/index";

import {
    IGpsItemsResponse, IGpsItemsCentralRecordsResponse, IGpsCountsResponse, IAddGpsDeviceResponse, IGpsDeviceListResponse, IGpsLookupDataResponse, IVerifyGpsNumberResponse, ActionCreators as GpsActionCreators
} from "./gps/index";

import {
    ISwapState, SwapActionCreators, SwapReducer,
    IListItemListResponse, ISwapLookupDataResponse, IRccapLookupDataResponse, IRccapPositionDetailResponse, IToggleGpsResponse,
    ILogisticsListResponse, ISavePositionDateTimeResponse, IMoveTrackerListResponse, IDonorShieldDirectListResponse, ILogisticsLookupDataResponse, IPositionResponse,
    ILogisticsOptionResponse, IMatchingSurgeriesAndRedeyeResponse, IMatchingCallsResponse,
    ActionTypes as SwapActionTypes, IDutyOfficerResponse, IGpsListResponse, IGpsBatchListResponse,
    IAvailableRecipient, IAvailableRecipientListResponse, IAvailableRecipientPairedDonor, ISwapLookupDataCenterListResponse
} from "./swaps/index"

import {
    ISwapSearchState, ISwapProfileSearchResponse, ActionCreators as DonorSwapActionCreators, ISwapDonorsLookupDataResponse, ISwapDonorResponse, ISwapDonorLookUpDataResponse,
    ISwapDonorLookupData, IDonorAliasDuplicateCheckResponse, IPairingRecipientDataResponse,
    IDonorConversionDataLookupResponse,
    IDonorConversionPostResponse,
    ISwapDonorDeleteResponse,
    ISpecificSwapProfileSearchResponse, IDonorSearchRequest
} from "./swap-donors/index";

import {
    ISwapTrackerState, SwapTrackerActionCreators, SwapTrackerReducer, ISwapTrackerListResponse
} from "./swap-tracker/index";

import {
    IEmailTemplateState, EmailTemplateReducer, EmailTemplateActionCreators,
    IAddEmailTagResponse, IDeleteEmailTagResponse, IDeleteSendeeResponse,
    IEmailFamilyState, EmailFamilyReducer, EmailFamilyActionCreators,
    IEmailFamilyResponse, IEmailTypeResponse, IEmailExcelIdResponse,
    IEmailModelState, EmailModelReducer, EmailModelActionCreators
} from "./email-engine/index";

import {
    IAdpDonorState, AdpDonorReducer, AdpDonorActionCreators, IVoucherHolderForListResponse, IVoucherHolderFileUploadResponse, IVoucherHolderResponse, IVoucherHolderLookupDataResponse,
    IAddVoucherHolderResponse
} from "./voucher/index"

import {
    IGalaContactsState, GalaContactsReducer, GalaContactsActionCreators
} from "./contact/gala/index"

import {
    IQaRegistrationState, QaRegistrationReducer, QaRegistrationActionCreators
} from "./qa/registration/index"

import {
    IShortCodeActionCreators, IShortCodeState
} from "./short-codes/index"

import {
    IReportState, Reducer as ReportReducer, ActionCreators as ReportActionCreators,
    ISwapQualityIssueReportResponse, IBillingReportResponse, IBillingPreparationReportResponse, ICenterBillingReportResponse, IInvoiceDetailReportResponse, IDonorExportabilityReportResponse, IPatientExportabilityReportResponse,
    ISwapFailureAnalysisResponse, IVxmAnalysisResponse, IInvoiceCreditPaymentsResponse, IPreselectReversalReportResponse, ISurgicalDeclineReportResponse, IUpcomingSwapCallsReportResponse,
    IChainEndDeclineRatioResponse, INkrDonorReferralConversionRateResponse, IInActiveReasonReports, IInActiveReasonReportResponse, IKidneyAvailOnTimeReports, IKidneyAvailOnTimeReportResponse,
    IChainEndOffersResponse, IMissedMatchOffersResponse, ICenterCLCScoresResponse, ICenterCLCDetailsResponse, ICenterCLCTargetedPairsResponse, IOrganPickupDeliveryReportResponse,
    IContractsSummaryResponse, IMissedRexmsResponse, IOverallPerformanceListResponse, IAccountsPayableReportResponse, IAccountsPayableOpoReportResponse, IAccountsReceivableReportResponse, IComparisonConversionResponse,
    IApDetailReportResponse, IDonorShieldHistoryReportResponse, IPatientOutcomesReportResponse, INcsScoresReportResponse, IHardToPlaceDonorsResponse, IPreSelectHistoryResponse, IHistogeneticsOrdersReportResponse, IApOpoDetailReportResponse,
    IPreSelectHistoryDetailsResponse, IHistogeneticsDetailReportResponse, IHistogeneticsDetailReports, IVrlDetailReportResponse, IVrlDetailReports, IQuestDetailReportResponse,
    ILateRexmReportResponse, ILateSerologiesReportResponse, IVxmAnalysisDetailReportResponse, IOnTimeKidneyPickupDetailReportResponse, INcsAuditResponse, ILateDonorReviewsResponse,
    IDashMonitoringResponse, ICenterChainEndOffersResponse, IFiveStarSurveyResponse, IComparisonVolumeResponse, ICprScoreResponse, ICprScoreAuditResponse, IWaitlistAuditResponse,
    ILateFinalXmResponse, ICenterDetailsResponse, IDashDonorUpdateResponse, IDashPatientDonorsResponse, IDonorBM3ValidatorResponse,
    ITransplantedPatientsResponse, ISerologyFinalXmBloodDrawsResponse, ISerologyBloodDrawsResponse
} from "./reports/index";

import {
    ICenterState, CenterReducer, CenterActionCreators, ICenterListResponse, ICenterSaturationListResponse,
    ICenterSummaryListResponse, IProductOwnerResponse, IClsOverrideResponse, IBasicCenterListResponse, IWaitListAllocationResponse,
    CenterEmailType,
    ICenterAddressListResponse, IAddUpdateCenterAddressResponse, ICenterAddressLookupDataResponse, ICenterFollowUpLabOptionListResponse, IAddUpdateFollowUpLabOptionResponse,
    IOptnSrtrDataProgressResponse, IOptnSrtrDataUploadResponse, IOptnSrtrDataValidateResponse, IOptnSrtrDataProcessResponse, IOptnSrtrMonthlyDataResponse, IUpdateOptnSrtrData, IOptnSrtrMonthlyDataAddResponse, IReferralConfigResponse, IReferralConfigLookupDataResponse,
    ICenterUnosDataResponse, ICenterProfileResponse, ICenterProfileLookupDataResponse, ICenterLabDataResponse, ICenterServicesDataResponse, ICenterSerologyDataResponse, ICenterAnatomyPrefsDataResponse, ICenterLegalDocumentsResponse, ICenterAdminDataResponse,
    IManualInvoiceLineItemLookupResponse, IManualInvoiceLineItemTaxResponse,
    ICenterPackagingDataResponse,
    IBulkCheekSwabDataResponse, IBulkCheekSwabRequest, OrganPackaging,
    ICenterProfileLookupData,
    initialCenterProfileLookupData
} from "./center/index";

import {
    IActionCenterState, ActionCenterReducer, ActionCenterActionCreators, IActionCenterLookupData,
    IActionCenterToDoResponse, IActionCenterOtherResponse, IActionCenterComplianceResponse,
    IActionCenterPendingSwapsResponse,
    IActionCenterLookupDataResponse, IActionCenterPerformanceResponse, IRmcrResponse,
    AdminActionCenterActionCreators,
    IAdminActionCenterToDoResponse, IAdminNotificationListResponse, IAdminNotificationResponse, IAdminActionCenterComplianceResponse, IAdminActionCenterOtherResponse,
    IRelativePerformanceResponse,
    IActionCenterCenterPerformanceImmediateAttentionAndComplianceResponse
} from "./action-center/index";

import {
    IBillingState, BillingReducer, BillingActionCreators,
    IBillingListResponse, IBillingDetailResponse, ISaveBillingDetails,
    INotBilledListResponse,
    INotBilled, IDonorEvalResponse,
    IApSbsResponse, IBilledByListResponse, IBilledToListResponse, ISearchListResponse, IBillingCenterReportResponse,
    IValidateAchRoutingNumberResponse
} from "./billing";

import {
    IAutomatedJobState, Reducer as AutomatedJobReducer, ActionCreators as AutomatedJobActionCreators, IAutomatedJobListResponse, IManualRunResponse,
    ICronListResponse, IQaCronListResponse,
    IQaCron
} from "./automated-jobs";

import {
    IDutyOfficerScheduleState, Reducer as DutyOfficerScheduleReducer, ActionCreators as DutyOfficerScheduleActionCreators,
    IDutyOfficerScheduleListResponse, IDutyOfficerSchedulesResponse, IDutyOfficerScheduleResponse, IStaffListResponse
} from "./duty-officer-schedule";

import {
    ICrmState, Reducer as CrmReducer, ActionCreators as CrmActionCreators,
    ICrmLookupDataResponse, ICrmAccountPlanResponse,
    ISaveProductCenterResponse,
    ProductSection, userContactMap, CenterOptionsOrigin, IProductListResponse, ISaveProductResponse,
    IProductCenterListResponse,
    IProductCenterResponse,
    IProductCenterForListResponse
} from './crm';

import {
    ITicketingState, Reducer as TicketingReducer, ActionCreators as TicketingActionCreators,
    ITicketResponse, ITicketMessageResponse, ITicketListResponse, ITicketGroupListResponse, ITicketGroupResponse, ITicketGroupCategoryListResponse,
    ITicketLookupDataResponse, ITagListResponse, ICannedResponseListResponse, ICannedResponseResponse
} from "./ticketing";

import {
    IRccapState, Reducer as RccapReducer, ActionCreators as RccapActionCreators,
    IRccapListResponse, IRccapResponse, ILookupData, IRccapStatusListResponse, IRccapAdminResponse, IRccapReportDetailResponse, ISwapFailureRateReportResponse
} from './rccap';

import {
    IContactState, Reducer as ContactReducer, ActionCreators as ContactActionCreators,
    IContactListResponse, IContactResponse, IContactPositionListResponse, IContactLookupDataResponse, IContactFullListResponse
} from './contact';

import {
    IReferralState, Reducer as ReferralReducer, ActionCreators as ReferralActionCreators, IReferralListResponse, IReferralResponse,
    IReferralLookupDataResponse, INkrReferralDonatedNkrResponse
} from './referrals';

import {
    IDonorSearchState, Reducer as DonorSearchReducer, ActionCreators as DonorSearchActionCreators,
    IDonorSearchResponse, IDonorSearchResults, IFindDashResponse, IFindDonorResponse, ICreateResponse, IExistsByAliasResponse,
    ILookupDataResponse, IFindDsdResponse
} from './donor-search';

import {
    AlleleOverrideActionCreators, IAlleleOverrideResponse
} from './hla';

import {
    IMicrositeState, Reducer as MicrositeReducer, ActionCreators as MicrositeActionCreators,
    IMicrositeResponse, ICommunicationResponse, ICoachLogEntryResponse,

    IMicrositeDashRegistration, IMicrositeShortCodeResponse, IMicrositeCampaignResponse, IRemoteDonorRegistrationResponse,
    IMicrositeCampaignValidatedMailingListResponse, IMicrositeCampaignListResponse, IMicrositeListResponse, IMicrositeCountResponse, IMicrositeLookupDataResponse,
    ICreateCardBatchResponse, IMicrositeCampaignLookupDataResponse, IMicrositeEmailTypeListResponse,
    IExistingRegistrationsResponse, IDashRegistrationForTransplantedList, IDashRegistrationsForTransplantedResponse, IDataForTransplantedResponse, IRecipientForTransplantedList, IMarkTransplantedRequest, IMicrositeLinkedEntities, IChangeStatusResponse, IChangeStatusRequest,
    IBulkChangeStatusResponse, IBulkChangeStatusResult, BulkChangeStatusOutcome,
    IChangeCoachStatusRequest, IMicrositeRecipientSurveyResponse, ISaveMicrositeRecipientSurveyResponse
} from './microsites';

import {
    ActionCreators as DonorActionCreators, IDonorAliasResponse,
    ActionCreatorsFollowUp as FollowUpActionCreators, IFollowUpSurveyCountsResponse, IFollowUpSurveyListResponse, IFollowUpSurveyResponse, IFollowUpDonorListResponse,
    ActionCreatorsFollowUpDonors as FollowUpDonorActionCreators, IExistingDashRegistration, IExistingDonor,
    IFollowUpDonorLookupDataResponse, IFollowUpDonorRecordsByEmailResponse, IFollowUpDonorVerifyEmailResponse, IFollowUpDonorSaveResponse, IFollowUpDonorResponse,
    ActionCreatorsFollowUpReports as FollowUpReportsActionCreators, IFollowUpComplianceReportResponse, IDonorProfileAdminResponse, IDonorProfileDonorDataResponse,
    IDonorProfileDonorDataLookupDataResponse, IDonorProfileMedicalDetailsResponse, IDonorProfileMedicalDetailsLookupDataResponse, IDonorProfileHlaInfoResponse,
    IDonorProfileHlaInfoLookupDataResponse, IDonorProfileRecordsResponse, IAmbraDirectToViewerResponse, IDonorProfileCtScanResponse, IDonorProfileDeclinesResponse, IDonorProfileHlaInfoPostDataResponse,
    IDonorProfileAcceptsResponse, IDonorProfileDonorAddressResponse, IDonorProfileDonorAddressPostResponse, IDonorProfileDonorAddressLookupDataResponse, IDonorProfileHeaderInfoResponse,
    IDonorProfileOrderCheekSwabResponse,
    IDonorProfileUploadResponse, IDonorProfilePostTransplantResponse,
    IDonorProfileVoucherListResponse,
    IDonorMinDetailsResponse,

    ActionCreatorsNewDonorRecipient as NewDonorRecipientActionCreators, INewDonorRecipientlookupDataResponse, ICheckForExistingAliasAndMrnResponse, IExistingMatch, INewDonorRecipientSaveResponse
} from './donor';

import {
    ActionCreators as RecipientActionCreators, IPreselectListResponse, IPotentialDonorListResponse, IEnrollmentRequest, IRecipientDataResponse, IRecipientShieldLookupResponse,
    IWaitlistImportUploadResponse,
    IWaitlistImportProcessResponse,
    IHighDeclineListResponse,
    ITransplantedRecipientListResponse,
    IRecipientLookupResponse,
    IRecipientRequest,
    IAdminRecipientListResponse,
    IRecipientReportLogResponse,
    ICenterRecipientListResponse,
    IAdminRecipientSaveResponse,
    IRecipientLabsReviewedResponse,
    IToolboxAvoidsRequest, IRecipientSaveToolboxAvoidsResponse,
    IEmpletMMDataResponse,
    IDonorFactSheetDataResponse,
    IRecipientXmResponse,
    IRecipientActivityLogResponse,
    IRecipientDonorDeclinesResponse,
    IRecipientCenterDataResponse,
    IRecipientAliasDuplicateCheckResponse,
    IPatientIntakeListResponse, IPatientIntakeResponse, IPatientIntakeLookupDataResponse,
    IRecipientListByCenterResponse,
    IRecipientByCenter,
    ICompatibilityResultsResponse,
    IRecipientContactInfoResponse,
    IRecipientMedicalDetailsResponse,
    IRecipientProfileHlaInfoResponse,
    IAntibodyScreeningResponse,
    IRecipientProfileRecordsResponse,
    IRecipientProfileRecordsPostResponse,
    IAntibodyScreeningResultResponse,
    IRecipientVoucherResponse,
    IRecipientPostTransplantResponse,
    IRecipientHeaderInfoResponse,
    IRecipientGeneralDataResponse,
    IRecipientVoucherLookUpResponse,
    IRecipientFinancialInfoResponse,
    IRecipientFinancialInfoPostResponse,
    IRecipientMinDetailsResponse,
    IRecipientForSidebarResponse,
    IRecipientPairedDonorsListResponse,
    IPairedDonor,
    IAdminUpdateRecipientRequest,
    IEpletGraphDataResponse, IEpletGraphDataResult, IRecipientSearchRequest,
    IPassMicrositeRecipientProfile,
    IUpdateWorkflowDetailsRequest,
    IPatientIntakeListReplacementResponse,
    IListRequest,
    IPreselectLookupData
} from './recipient';

import {
    ActionCreators as RecipientShieldActionCreators
} from './recipient-shield';

import {
    IMatchResponse, ActionCreators as MatchActionCreators, IMatchOfferAccept, IMatchOfferDecline, ICrossMatchAccept, ICrossMatchDecline,
    IEvaluateRecipientDonorResponse, IMatchDeadlineListResponse
} from './match';

import {
    ActionCreators as NkrLabActionCreators
} from './nkr-lab';

import {
    ActionCreators as ExpertSystemActionCreators, IExpertSystemOrderResponse, ILookupDataResponse as IExportSystemLookupDataResponse,
    IExpertSystemRegistrationResponse, IExpertSystemDonorResponse, IExpertSystemRecipientResponse
} from './expert-system';

import {
    ActionCreators as XmTrackingActionCreators, XmListType, IXmTrackingResponse, IXmTrackingListResponse, IXmTrackingCountResponse,
    IXmTrackingLookupDataResponse, IXmTrackingCenterCountResponse
} from './xm-tracking';

import {
    ActionCreators as SerologyTrackingActionCreators, SerologyListType, ISerologyTrackingResponse, ISerologyTrackingListResponse, ISerologyLookupDataResponse,
    ISerologyTrackingCountsResponse
} from './serology-tracking';

import {
    IDashState, Reducer as DashReducer, ActionCreators as DashActionCreators,
    IDonorConnectListResponse, IDonnorConnectLogListResponse, IDonnorConnectLogResponse,
    IDonorConnectLookupDataResponse, IDonorConnectMentorPerformanceResponse,
    IDonorConnectUserListResponse, IDonorConnectNextMilestoneResponse,
    IDashSelfServeReconciliationUploadResponse,
    IDashSelfServeReconciliationProcessResponse,
    IDashSelfServeReconciliationCreateResponse,
    IIncidentReportLookUpResponse,
    IMentorCompletionsListResponse, ICenterContactsResponse,
    IDonorConnectCompletionsReportResponse, IIncidentReportLogResponse,
    IIldaListResponse, IIldaCountResponse, IIldaLogListResponse, IIldaLogResponse, IIncidentReportListResponse, IIldaRegistrationResponse,
    IIldaLookupDataResponse, IIldaUserListResponse, IIldaUploadedFilesListResponse, IFindForTransferResponse, ITransferResponse, IDuplicateListResponse, IDuplicateListMentorChangeResponse,
    IIncidentReportResponse, IVariableReportListResponse, IVariableReportLookUpResponse, IVariableTextResponse, IMailingAddress
} from './dash';

import {
    DashCenterActionCreators, ICenterDashListResponse, IDashLogListResponse, IDashLookupDataResponse, IDashLogResponse,
    IStatusListResponse, IDispositionListResponse, IReportRemoteDonationPreferredResponse,
    IDiagnosticResponse, IDiagnosticLookupDataResponse, ICenterDashDetailResponse, IDashCenterLookupDataResponse, IPwlDetailsResponse,
    IShippedJug,
    IResultsUploaded,
    IRegistrationDetailsForPwl,
    IPwlDetails,
    IDonorIntakeFullNameResponse,
    IExpertSystemEnrollResponse, ICheckDonorProfileResponse, IRecipientCoordListLookupDataResponse,
    IUploadLabsResponse
} from './donor-intake';

import {
    DonorShieldDirectActionCreators, IDonorShieldDirectResponse, IDonorShieldLookupDataResponse, IDonorShieldDirectRequestCountsResponse, IDonorShieldDirectDataResponse, IDashDonorExistingResponse, IDonorShieldDirectDuplicateCountResponse, IDonorShieldDirectSaveRequest,
    IDonorShieldAliasCheckResponse, IResendRegistrationInviteResponse
} from './donor-shield-direct';

import {
    WatrActionCreators, IWatrRequestResponse, IWatrRequestCountsResponse, IWatrRequestUpdateResponse, IWatrDuplicateCountResponse, IWatrChaseExportListResponse, IWatrDetailsDataResponse,
    IWatrRequestLookupDataResponse,
    IReimbursementUpdateResponse,
    IWatrAuditLogResponse,
    IReimbursementEntryResponse,
    IWatrConfirmReimbursementItem,
    IConfirmReimbursementsResponse,
    IWatrReimbursementResponse,
    IWatrLogsResponse,
    IWatrUpdateDonorRequest,
    IWatrChaseUploadResponse,
    IPendingRegistrationDonorsResponse
} from './watr';

import {
    IInvoiceTransplantListResponse, IInvoiceTransplantRequest, InvoicingActionCreators
} from './invoicing';

import {
    PhlebotActionCreators, IPhlebotRequestResponse, IPhlebotLookupResponse
} from './phlebot-service';

import {
    ITargetState, Reducer as TargetReducer, ActionCreators as TargetActionCreators,
    IDonorsPerMonthByAboResponse, IGetAllResponse, IGetAllNewResponse
} from "./target";

import {
    IDonorPreselectState, Reducer as DonorPreselectReducer, ActionCreators as DonorPreselectActionCreators, IAcceptDonorResponse, IRequestExmResponse
} from './donor-preselect';

import { FileActionCreators } from './file/actions';

import {
    ICenterNotificationState, Reducer as CenterNotificationReducer,
    ActionCreators as CenterNotificationActionCreators,
    ICenterNotificationListResponse, ICenterNotificationCreateResponse, INotificationLookupDataResponse
} from './notifications';

import {
    ActionCreators as SystemConfigActionCreators, ISystemConfigResponse
} from './system-config';

import {
    ActionCreators as MatchingActionCreators,
    IConfigureMatchRunResponse, IMatchRunListResponse, IMatchRunResponse, IMatchRunResultsResponse, IRequestRexmResponse,
    IRequestRexmBatchResponse,
    ISubmitMatchRunResponse,
    IMatchRunScenariosResponse
} from './matching';

import {
    ActionCreators as OpsScheduleActionCreators, IOpsScheduleListResponse, IOpsScheduleRefreshResponse,
    IOpsScheduleSaveResponse
} from './ops';

import { ActionCreators as OpoActionCreators, IOpoListResponse, IOpoLookupDataResponse, IOpoAddResponse, IOpoCheckForExistingAliasResponse, IOpoResponse, IOpoAddUpdateRequest } from './opo';
import { IHomeBloodDrawRequest } from "../models";

import { ActionCreators as ArchiveInfoCreators, IArchiveInfoResponse } from './info'

import {
    INetworkEmailState, Reducer as NetworkEmailReducer, ActionCreators as NetworkEmailActionCreators,
    INetworkEmailLookupDataResponse, INetworkEmailDefaultContentResponse, ISendEmailRequest
} from './network-email';

import { ActionCreators as SwapQualityIssueActionCreators, ISwapQualityIssueListResponse, ISwapQualityIssueResponse, ISwapQualityLookupDataResponse, ISwapQualityIssueCountResponse, ISwapQualityIssueRequest } from './swap-quality-issues';

import {
    IVoucherSimulationState,
    Reducer as VoucherSimulationReducer,
    ActionCreators as VoucherSimulationActionCreators,
    IVoucherSimulationConfigOverride,
    IVoucherSimulationConfigDefaultsResponse,
    IVoucherSimulationResponse,
    IVoucherSimulationSummaryResponse,
    IVoucherSimulationRunResponse
} from './voucher-simulation';

import { OrdersActionCreators as OrdersActionCreators, ICheekSwabOrderResponse, ISerologyTestsResponse, ILookupLabAddressResponse } from './orders';
import { IAddressValidationResponse } from './address-validation-response';

// The top-level state object
export interface IApplicationState {
    app: IAppState,
    auth: IAuthState,
    users: IUserListState,
    swaps: ISwapState,
    oneWays: ISwapTrackerState,
    emailTemplates: IEmailTemplateState,
    emailFamilies: IEmailFamilyState,
    emailModels: IEmailModelState,
    adpDonors: IAdpDonorState,
    galaContacts: IGalaContactsState,
    registrationSteps: IQaRegistrationState,
    reports: IReportState,
    centers: ICenterState
    actionCenter: IActionCenterState,
    billing: IBillingState,
    automatedJobs: IAutomatedJobState,
    dutyOfficerSchedule: IDutyOfficerScheduleState
    crm: ICrmState,
    ticketing: ITicketingState,
    rccap: IRccapState,
    contact: IContactState,
    referral: IReferralState,
    donorSearch: IDonorSearchState,
    microsites: IMicrositeState,
    dash: IDashState,
    target: ITargetState,
    donorPreselectState: IDonorPreselectState,
    centerNotifications: ICenterNotificationState,
    networkEmail: INetworkEmailState,
    voucherSimulation: IVoucherSimulationState
}

// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.
// export const reducers = {
//     counter: Counter.reducer,
//     weatherForecasts: WeatherForecasts.reducer
// };

export const Reducers = {
    app: AppReducer,
    auth: AuthReducer,
    users: UserListReducer,
    swaps: SwapReducer,
    oneWays: SwapTrackerReducer,
    emailTemplates: EmailTemplateReducer,
    emailFamilies: EmailFamilyReducer,
    emailModels: EmailModelReducer,
    vouchers: AdpDonorReducer,
    registrationSteps: QaRegistrationReducer,
    reports: ReportReducer,
    centers: CenterReducer,
    actionCenter: ActionCenterReducer,
    billing: BillingReducer,
    automatedJobs: AutomatedJobReducer,
    dutyOfficerSchedule: DutyOfficerScheduleReducer,
    crm: CrmReducer,
    ticketing: TicketingReducer,
    rccap: RccapReducer,
    contact: ContactReducer,
    referral: ReferralReducer,
    donorSearch: DonorSearchReducer,
    microsites: MicrositeReducer,
    dash: DashReducer,
    target: TargetReducer,
    donorPreselect: DonorPreselectReducer,
    centerNotifications: CenterNotificationReducer,
    networkEmail: NetworkEmailReducer,
    voucherSimulation: VoucherSimulationReducer
};

// This type can be used as a hint on action creators so that its 'dispatch' and 'getState' params are
// correctly typed to match your store.
// export interface AppThunkAction<TAction> {
//     (dispatch: (action: TAction) => void, getState: () => ApplicationState): void;
// }

export type AppThunkAction<TAction> = (dispatch: (action: TAction) => void, getState: () => IApplicationState) => void;

export {
    IAppState, AppActionCreators, AppReducer, ICenterResponse, ICenterMetricsResponse, IArrayResponse, IObjectResponse, IClsOverrideResponse, IWaitListAllocationResponse,
    IBasicCenterListResponse, CenterEmailType,
    ICenterAddressListResponse, IAddUpdateCenterAddressResponse, ICenterAddressLookupDataResponse, ICenterFollowUpLabOptionListResponse, IAddUpdateFollowUpLabOptionResponse,
    IOptnSrtrDataUploadResponse, IOptnSrtrDataValidateResponse, IOptnSrtrDataProcessResponse, IOptnSrtrDataProgressResponse,
    IOptnSrtrMonthlyDataResponse, IUpdateOptnSrtrData, IOptnSrtrMonthlyDataAddResponse,
    ICenterProfileLookupDataResponse,
    ICenterAdminDataResponse,
    ICenterUnosDataResponse, ICenterProfileResponse, ICenterLabDataResponse, ICenterServicesDataResponse, ICenterSerologyDataResponse, ICenterAnatomyPrefsDataResponse,
    ICenterLegalDocumentsResponse, IManualInvoiceLineItemLookupResponse, IManualInvoiceLineItemTaxResponse, ICenterPackagingDataResponse, OrganPackaging,
    ICenterProfileLookupData, initialCenterProfileLookupData,
    IValidateAchRoutingNumberResponse,
    IBulkCheekSwabDataResponse, IBulkCheekSwabRequest,

    IAuthState, IAuthCheck, AuthActionCreators, AuthReducer,

    IUserListState, UserActionCreators, UserListReducer, IVerifyAuthCodeResponse, IRoleListResponse, IGroupListResponse,
    IUserLookupDataResponse,
    IGpsItemsResponse, IGpsItemsCentralRecordsResponse, IGpsCountsResponse, IAddGpsDeviceResponse, IGpsDeviceListResponse, IGpsLookupDataResponse, IVerifyGpsNumberResponse, GpsActionCreators,
    IGroupLookupDataResponse, IAddUpdateGroupResponse, IGroupData,

    ISwapState, SwapActionCreators, SwapReducer, SwapActionTypes,
    ISwapLookupDataResponse, IListItemListResponse, IRccapLookupDataResponse, IRccapPositionDetailResponse, ILogisticsLookupDataResponse,

    IToggleGpsResponse, ILogisticsListResponse, ISavePositionDateTimeResponse, IMoveTrackerListResponse, IDonorShieldDirectListResponse,

    ISwapTrackerState, SwapTrackerActionCreators, SwapTrackerReducer, ISwapTrackerListResponse, IPositionResponse,

    ILogisticsOptionResponse, IMatchingSurgeriesAndRedeyeResponse, IMatchingCallsResponse, IDutyOfficerResponse, IGpsListResponse, IGpsBatchListResponse,
    IAvailableRecipient, IAvailableRecipientPairedDonor, IAvailableRecipientListResponse, ISwapLookupDataCenterListResponse,

    IEmailTemplateState, EmailTemplateActionCreators, EmailTemplateReducer,
    IAddEmailTagResponse, IDeleteEmailTagResponse, IDeleteSendeeResponse,
    IEmailFamilyState, EmailFamilyActionCreators, EmailFamilyReducer,
    IEmailFamilyResponse, IEmailTypeResponse, IEmailExcelIdResponse,
    IEmailModelState, EmailModelActionCreators, EmailModelReducer,

    IAdpDonorState, AdpDonorActionCreators, AdpDonorReducer, IVoucherHolderForListResponse, IVoucherHolderFileUploadResponse,
    IVoucherHolderResponse, IVoucherHolderLookupDataResponse, IAddVoucherHolderResponse,

    IGalaContactsState, GalaContactsActionCreators, GalaContactsReducer,

    IQaRegistrationState, QaRegistrationReducer, QaRegistrationActionCreators,

    IShortCodeState, IShortCodeActionCreators,

    IReportState, ReportReducer, ReportActionCreators,
    ISwapQualityIssueReportResponse, IBillingReportResponse, IBillingPreparationReportResponse, ICenterBillingReportResponse, IInvoiceDetailReportResponse,
    ISwapFailureAnalysisResponse, IVxmAnalysisResponse, IInvoiceCreditPaymentsResponse,
    IChainEndDeclineRatioResponse, INkrDonorReferralConversionRateResponse, IChainEndOffersResponse, IMissedMatchOffersResponse,
    IContractsSummaryResponse, IMissedRexmsResponse, IOverallPerformanceListResponse, IAccountsPayableReportResponse, IApDetailReportResponse, IApOpoDetailReportResponse,
    IAccountsPayableOpoReportResponse, IAccountsReceivableReportResponse, ILateRexmReportResponse,
    ILateSerologiesReportResponse, IVxmAnalysisDetailReportResponse, IOnTimeKidneyPickupDetailReportResponse, INcsAuditResponse, ILateDonorReviewsResponse, IDashMonitoringResponse,
    ICenterChainEndOffersResponse, IFiveStarSurveyResponse, IComparisonConversionResponse, IComparisonVolumeResponse, ICprScoreResponse, ICprScoreAuditResponse, IWaitlistAuditResponse,
    ILateFinalXmResponse, ICenterDetailsResponse, IDashDonorUpdateResponse, IDashPatientDonorsResponse, IDonorBM3ValidatorResponse,
    ITransplantedPatientsResponse, ISerologyFinalXmBloodDrawsResponse, ISerologyBloodDrawsResponse,

    ICenterState, CenterActionCreators, ICenterListResponse, ICenterSaturationListResponse, ICenterSummaryListResponse, IProductOwnerResponse,

    IActionCenterState, ActionCenterActionCreators, IActionCenterLookupData,
    IActionCenterToDoResponse, IActionCenterOtherResponse, IActionCenterComplianceResponse,
    IActionCenterPendingSwapsResponse,
    IActionCenterLookupDataResponse, IActionCenterPerformanceResponse, IRmcrResponse,
    IRelativePerformanceResponse,
    IActionCenterCenterPerformanceImmediateAttentionAndComplianceResponse,
    AdminActionCenterActionCreators, IAdminActionCenterToDoResponse, IAdminActionCenterComplianceResponse, IAdminActionCenterOtherResponse, IAdminNotificationListResponse, IAdminNotificationResponse,

    IBillingState, BillingActionCreators, IBillingListResponse, IBillingDetailResponse, ISaveBillingDetails,
    INotBilledListResponse,
    INotBilled, IDonorEvalResponse,
    IApSbsResponse, IBilledByListResponse, IBilledToListResponse, ISearchListResponse, IBillingCenterReportResponse,

    IAutomatedJobState, AutomatedJobActionCreators, IAutomatedJobListResponse, ICronListResponse, IManualRunResponse, IQaCronListResponse, IQaCron,

    IDutyOfficerScheduleState, DutyOfficerScheduleActionCreators, IDutyOfficerScheduleListResponse, IDutyOfficerSchedulesResponse, IDutyOfficerScheduleResponse, IStaffListResponse,

    ICrmState, CrmActionCreators, ICrmLookupDataResponse, ICrmAccountPlanResponse,

    IProductCenterListResponse,
    IProductCenterResponse,
    ISaveProductCenterResponse,
    IProductCenterForListResponse,
    ProductSection, userContactMap, CenterOptionsOrigin, IProductListResponse, ISaveProductResponse,

    ITicketingState, TicketingActionCreators, ITicketResponse, ITicketMessageResponse, ITicketListResponse, ITicketGroupListResponse, ITicketGroupResponse, ITicketGroupCategoryListResponse,
    ITicketLookupDataResponse, ITagListResponse, ICannedResponseListResponse, ICannedResponseResponse,

    IRccapState, RccapActionCreators, IRccapListResponse, IRccapResponse, ILookupData, IRccapStatusListResponse, IRccapAdminResponse,
    IRccapReportDetailResponse, ISwapFailureRateReportResponse, ISwapSearchState, ISwapProfileSearchResponse, DonorSwapActionCreators, ISwapDonorsLookupDataResponse, ISwapDonorLookUpDataResponse, ISwapDonorLookupData, ISwapDonorResponse,
    IDonorAliasDuplicateCheckResponse, IPairingRecipientDataResponse, IDonorConversionDataLookupResponse, IDonorConversionPostResponse,

    IContactState, ContactActionCreators, IContactListResponse, IContactResponse, IContactPositionListResponse, IContactLookupDataResponse, IContactFullListResponse,

    IReferralState, ReferralActionCreators, IReferralLookupDataResponse, IReferralListResponse, IReferralResponse, INkrReferralDonatedNkrResponse,

    IDonorSearchState, DonorSearchActionCreators, IDonorSearchResponse, IDonorSearchResults, IFindDashResponse, IFindDonorResponse, ICreateResponse, IExistsByAliasResponse,
    ILookupDataResponse, IFindDsdResponse,
    IDashSelfServeReconciliationUploadResponse, IDashSelfServeReconciliationProcessResponse,

    AlleleOverrideActionCreators, IAlleleOverrideResponse,

    MicrositeActionCreators,
    IMicrositeResponse, ICommunicationResponse, ICoachLogEntryResponse,
    IMicrositeDashRegistration, IRemoteDonorRegistrationResponse,
    IMicrositeShortCodeResponse, IMicrositeCampaignResponse, IMicrositeCampaignValidatedMailingListResponse, IMicrositeCampaignListResponse, IMicrositeCampaignLookupDataResponse,
    IMicrositeListResponse, IMicrositeCountResponse, IMicrositeLookupDataResponse, ICreateCardBatchResponse,
    IMicrositeEmailTypeListResponse, IExistingRegistrationsResponse, IDashRegistrationForTransplantedList,
    IDashRegistrationsForTransplantedResponse, IDataForTransplantedResponse, IRecipientForTransplantedList, IMarkTransplantedRequest,
    IMicrositeLinkedEntities, IChangeStatusResponse, IChangeStatusRequest, IChangeCoachStatusRequest,
    IBulkChangeStatusResponse, IBulkChangeStatusResult, BulkChangeStatusOutcome, IMicrositeRecipientSurveyResponse, ISaveMicrositeRecipientSurveyResponse,

    DonorActionCreators,
    FollowUpActionCreators, IFollowUpSurveyCountsResponse, IFollowUpSurveyListResponse, IFollowUpSurveyResponse, IFollowUpDonorListResponse,
    FollowUpDonorActionCreators, IExistingDashRegistration, IExistingDonor,
    IFollowUpDonorResponse, IFollowUpDonorLookupDataResponse, IFollowUpDonorVerifyEmailResponse, IFollowUpDonorRecordsByEmailResponse,
    IFollowUpDonorSaveResponse,
    FollowUpReportsActionCreators, IFollowUpComplianceReportResponse,

    NewDonorRecipientActionCreators, INewDonorRecipientlookupDataResponse, ICheckForExistingAliasAndMrnResponse, IExistingMatch,
    INewDonorRecipientSaveResponse,

    RecipientActionCreators,
    RecipientShieldActionCreators,
    ITransplantedRecipientListResponse,
    IPreselectListResponse, IPotentialDonorListResponse, IRecipientDataResponse, IEnrollmentRequest, IRecipientShieldLookupResponse,
    IWaitlistImportUploadResponse,
    IWaitlistImportProcessResponse, IRecipientLookupResponse, IRecipientRequest, IAdminRecipientListResponse, IAdminRecipientSaveResponse, IRecipientReportLogResponse,
    IHighDeclineListResponse, ICenterRecipientListResponse,
    IToolboxAvoidsRequest,
    IRecipientLabsReviewedResponse, IEmpletMMDataResponse, IDonorFactSheetDataResponse,
    IRecipientSaveToolboxAvoidsResponse,
    IPatientIntakeListResponse, IPatientIntakeListReplacementResponse, IPatientIntakeResponse, IPatientIntakeLookupDataResponse, IListRequest,
    IPreselectLookupData,
    IRecipientListByCenterResponse, IRecipientByCenter, ICompatibilityResultsResponse,
    IRecipientXmResponse, IRecipientActivityLogResponse, IRecipientDonorDeclinesResponse, IRecipientCenterDataResponse, IRecipientAliasDuplicateCheckResponse,
    IRecipientHeaderInfoResponse,
    IRecipientVoucherLookUpResponse,
    IRecipientGeneralDataResponse,
    IRecipientContactInfoResponse, IRecipientMedicalDetailsResponse,
    IRecipientProfileHlaInfoResponse,
    IAntibodyScreeningResponse, IRecipientProfileRecordsResponse, IRecipientProfileRecordsPostResponse,
    IAntibodyScreeningResultResponse, IRecipientVoucherResponse,
    IRecipientPostTransplantResponse,
    IRecipientFinancialInfoResponse, IRecipientFinancialInfoPostResponse,
    IRecipientMinDetailsResponse, IRecipientForSidebarResponse, IRecipientPairedDonorsListResponse, IPairedDonor, IAdminUpdateRecipientRequest,
    IEpletGraphDataResponse, IEpletGraphDataResult, IRecipientSearchRequest,
    IPassMicrositeRecipientProfile, IUpdateWorkflowDetailsRequest,

    IMatchResponse, MatchActionCreators, IMatchOfferAccept, IMatchOfferDecline, ICrossMatchAccept, ICrossMatchDecline, IEvaluateRecipientDonorResponse,
    IMatchDeadlineListResponse,
    NkrLabActionCreators, ExpertSystemActionCreators, IExpertSystemOrderResponse, IExportSystemLookupDataResponse,
    IExpertSystemRegistrationResponse, IExpertSystemDonorResponse, IExpertSystemRecipientResponse,

    IDashState, DashActionCreators,
    IDonorConnectListResponse, IDonnorConnectLogListResponse, IDonnorConnectLogResponse, IDonorConnectLookupDataResponse,
    IDonorConnectUserListResponse, IDonorConnectNextMilestoneResponse, ICenterContactsResponse,
    IDashSelfServeReconciliationCreateResponse, IIncidentReportLookUpResponse, IMentorCompletionsListResponse, IVariableReportListResponse, IVariableReportLookUpResponse, IVariableTextResponse,
    IDonorConnectCompletionsReportResponse, IFindForTransferResponse, ITransferResponse, IIncidentReportLogResponse,
    IIldaListResponse, IIldaCountResponse, IIldaLogListResponse, IIldaLogResponse, IIncidentReportListResponse, IIldaRegistrationResponse,
    IIldaLookupDataResponse, IIldaUserListResponse, IIldaUploadedFilesListResponse, IDuplicateListResponse, IDuplicateListMentorChangeResponse,
    IIncidentReportResponse, IInvoiceTransplantListResponse, IInvoiceTransplantRequest, InvoicingActionCreators,
    IMailingAddress,

    DashCenterActionCreators, DonorShieldDirectActionCreators, IDiagnosticResponse, IDiagnosticLookupDataResponse, ICenterDashDetailResponse, IDashCenterLookupDataResponse,
    IPwlDetailsResponse, IPwlDetails, IRegistrationDetailsForPwl, IResultsUploaded, IShippedJug,
    IDonorIntakeFullNameResponse, IRecipientCoordListLookupDataResponse, IUploadLabsResponse,
    IExpertSystemEnrollResponse, ICheckDonorProfileResponse,
    ICenterDashListResponse, IDashLogListResponse, IDashLookupDataResponse, IDashLogResponse, IStatusListResponse, IDispositionListResponse, IDonorShieldDirectResponse, IDonorShieldLookupDataResponse, IDonorShieldDirectRequestCountsResponse,

    IReportRemoteDonationPreferredResponse, IPatientOutcomesReportResponse, IPreselectReversalReportResponse, IDonorConnectMentorPerformanceResponse, INcsScoresReportResponse, IHardToPlaceDonorsResponse, IDonorShieldDirectDataResponse, IDashDonorExistingResponse, IDonorShieldDirectDuplicateCountResponse, IDonorShieldAliasCheckResponse,
    IDonorShieldDirectSaveRequest, IResendRegistrationInviteResponse,

    IPreSelectHistoryResponse, IPreSelectHistoryDetailsResponse, IHistogeneticsOrdersReportResponse, IHistogeneticsDetailReportResponse, IHistogeneticsDetailReports, IVrlDetailReportResponse, IVrlDetailReports,
    IQuestDetailReportResponse, WatrActionCreators, IWatrRequestResponse, IWatrRequestUpdateResponse, IWatrDuplicateCountResponse, IWatrChaseExportListResponse, IWatrDetailsDataResponse,
    IWatrRequestLookupDataResponse, IReimbursementUpdateResponse, IWatrAuditLogResponse,
    IReimbursementEntryResponse, IWatrRequestCountsResponse, IWatrReimbursementResponse, IWatrLogsResponse, IWatrUpdateDonorRequest, IWatrChaseUploadResponse, IWatrConfirmReimbursementItem, IConfirmReimbursementsResponse, IPendingRegistrationDonorsResponse,

    PhlebotActionCreators, IPhlebotRequestResponse, IPhlebotLookupResponse,

    IHomeBloodDrawRequest,

    ITargetState, TargetActionCreators,
    IDonorsPerMonthByAboResponse, IDonorShieldHistoryReportResponse, IOrganPickupDeliveryReportResponse, ISurgicalDeclineReportResponse, IUpcomingSwapCallsReportResponse, IDonorExportabilityReportResponse, IPatientExportabilityReportResponse,
    IGetAllResponse, IGetAllNewResponse,

    IDonorPreselectState, DonorPreselectActionCreators, IAcceptDonorResponse, IRequestExmResponse, IKidneyAvailOnTimeReports, IKidneyAvailOnTimeReportResponse,

    FileActionCreators, ICenterCLCScoresResponse, ICenterCLCDetailsResponse, ICenterCLCTargetedPairsResponse, IInActiveReasonReports, IInActiveReasonReportResponse,

    ICenterNotificationState, CenterNotificationActionCreators, ICenterNotificationListResponse, ICenterNotificationCreateResponse, INotificationLookupDataResponse,

    XmTrackingActionCreators, XmListType, IXmTrackingResponse, IXmTrackingListResponse, IXmTrackingCountResponse,
    IXmTrackingLookupDataResponse, IXmTrackingCenterCountResponse,

    SerologyTrackingActionCreators, SerologyListType, ISerologyTrackingResponse, ISerologyTrackingListResponse, ISerologyLookupDataResponse,
    ISerologyTrackingCountsResponse,

    SystemConfigActionCreators, ISystemConfigResponse, IReferralConfigResponse, IReferralConfigLookupDataResponse,

    MatchingActionCreators, IConfigureMatchRunResponse, IMatchRunListResponse, IMatchRunResponse, IMatchRunResultsResponse, IRequestRexmResponse,
    IRequestRexmBatchResponse,
    ISubmitMatchRunResponse, IMatchRunScenariosResponse,

    OpsScheduleActionCreators, IOpsScheduleListResponse, IOpsScheduleRefreshResponse, IOpsScheduleSaveResponse,

    ArchiveInfoCreators, IArchiveInfoResponse,
    OpoActionCreators, IOpoListResponse, IOpoLookupDataResponse, IOpoAddResponse, IOpoCheckForExistingAliasResponse, IOpoResponse, IOpoAddUpdateRequest,

    IDonorProfileAdminResponse, IDonorProfileDonorDataResponse, IDonorProfileDonorDataLookupDataResponse,
    IDonorProfileMedicalDetailsResponse, IDonorProfileMedicalDetailsLookupDataResponse,
    IDonorProfileHlaInfoResponse, IDonorProfileHlaInfoLookupDataResponse, IDonorProfileHlaInfoPostDataResponse,
    IDonorProfileRecordsResponse, IDonorAliasResponse,
    IDonorProfileCtScanResponse, IAmbraDirectToViewerResponse,
    IDonorProfileDeclinesResponse, IDonorProfileAcceptsResponse,
    IDonorProfileDonorAddressResponse, IDonorProfileDonorAddressPostResponse, IDonorProfileDonorAddressLookupDataResponse,
    IDonorProfileHeaderInfoResponse, IDonorProfileOrderCheekSwabResponse, IDonorProfileUploadResponse, IDonorProfilePostTransplantResponse,
    NetworkEmailActionCreators, INetworkEmailLookupDataResponse, INetworkEmailDefaultContentResponse, ISendEmailRequest,
    IDonorProfileVoucherListResponse,
    SwapQualityIssueActionCreators, ISwapQualityIssueListResponse, ISwapQualityIssueResponse, ISwapQualityLookupDataResponse, ISwapQualityIssueCountResponse, ISwapQualityIssueRequest,
    VoucherSimulationActionCreators, IVoucherSimulationConfigOverride, IVoucherSimulationConfigDefaultsResponse, IVoucherSimulationResponse, IVoucherSimulationSummaryResponse,
    IVoucherSimulationRunResponse,
    IDonorMinDetailsResponse, ISwapDonorDeleteResponse, ISpecificSwapProfileSearchResponse, IDonorSearchRequest,

    OrdersActionCreators, ICheekSwabOrderResponse, ISerologyTestsResponse, ILookupLabAddressResponse,

    IAddressValidationResponse
};
